import { Box, Button, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { Icon } from 'leaflet';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';

import MapNA from '../../../images/map_not_available.png';
import selectedSvg from '../../../images/markers/overview/marker-selected.svg';
import { parseLocation } from '../../../utils/location';

interface MalfunctionMapProps {
    location?: string;
    lastSeen?: number;
}

const MalfunctionMap: React.FC<MalfunctionMapProps> = (props: MalfunctionMapProps) => {
    const [blurMap, setBlurMap] = useState<boolean>(
        !!props.lastSeen && dayjs().subtract(7, 'day').isAfter(dayjs.unix(props.lastSeen)),
    );
    const { t } = useTranslation();
    const location = !!props.location ? parseLocation(props.location) : undefined;
    const daysAgo = !!props.lastSeen ? dayjs().diff(dayjs.unix(props.lastSeen), 'day') : 0;

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
            <Typography variant="overline">{t('content.malfunctions.details.map.header')}</Typography>
            <Box
                data-testid="map-container"
                data-hasmap={!!location ? 'true' : 'false'}
                sx={{
                    width: '100%',
                    height: '175px',
                    flexShrink: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                {!!location ? (
                    <>
                        <MapContainer
                            key={blurMap.toString()}
                            attributionControl={false}
                            zoomSnap={0.5}
                            id="map-widget"
                            style={{ height: '100%', width: '100%', filter: blurMap ? 'blur(3px)' : undefined }}
                            center={location}
                            zoom={16}
                            zoomControl={!blurMap}
                        >
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                className="leaflet-light"
                            />
                            {!blurMap ? (
                                <Marker
                                    position={location}
                                    icon={new Icon({ iconUrl: selectedSvg, iconAnchor: [12.5, 35] })}
                                />
                            ) : null}
                        </MapContainer>
                        {blurMap && !!daysAgo ? (
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    zIndex: 1001,
                                    position: 'absolute',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography textAlign="center">
                                    {t('content.malfunctions.details.map.old_location', { days: daysAgo })}
                                </Typography>
                                <Button
                                    id="btn-show-map"
                                    data-testid="btn-show-map"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => setBlurMap(false)}
                                    sx={{ mt: 1 }}
                                >
                                    {t('content.malfunctions.details.map.view_location')}
                                </Button>
                            </Box>
                        ) : null}
                    </>
                ) : (
                    <img src={MapNA} height="100%" style={{ objectFit: 'contain' }} />
                )}
            </Box>
        </Box>
    );
};

export default MalfunctionMap;
